<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39 42v-1h-1.3l1.3 1z"/><path d="M43 24h-5V5.67A1.7 1.7 0 0036.3 4H5.7A1.7 1.7 0 004 5.67v25.47a1.7 1.7 0 001.7 1.7h8.5v3.46a1.7 1.7 0 001.71 1.7 1.66 1.66 0 001-.33l6.65-4.83H24V40a1 1 0 001 1h7.5l3.91 2.85A1 1 0 0037 44a1 1 0 001-1v-2h5a1 1 0 001-1V25a1 1 0 00-1-1zm-20.43 5.84l-.78.57-4.59 3.33v-3.9H7V7h28v22.85H22.57zM42 39h-6v2l-2.32-1.69-.53-.31H26v-6.16h10.3a1.7 1.7 0 001.7-1.7V26h4z"/></svg>